import React from 'react'
import { Link } from 'react-router-dom'
import { ArchiveBoxIcon, DocumentTextIcon } from '@heroicons/react/24/solid'
import { FaFilePen } from 'react-icons/fa6'
import AppShell from '../../../Components/AppShell'
import PageHeader from '../../../Components/PageHeader'
import ToolCard from '../../../Components/ToolCard'

const WarehouseToolsView = () => {
  return (
    <AppShell>
      <PageHeader
        kicker="Warehouse"
        title="Warehouse tools"
        subtitle="Process refund audits and Extensiv file converters."
        crumbs={[
          { label: 'Home', to: '/home' },
          { label: 'Warehouse' },
        ]}
      />

      <div className="grid grid-cols-1 gap-4 md:grid-cols-2 xl:grid-cols-3">
        <ToolCard
          title="Warehouse Refunds"
          description="Upload batches, track refund status, and process returns."
          icon={ArchiveBoxIcon}
          to="/warehouse-tools/warehouse-refunds"
          badge="Active"
        />

        <article className="nx-panel flex h-full flex-col gap-4 p-5">
          <div className="flex items-start justify-between gap-3">
            <div className="flex h-11 w-11 items-center justify-center rounded-lg border border-rule bg-surface text-signal">
              <DocumentTextIcon className="h-5 w-5" aria-hidden />
            </div>
            <span className="nx-chip-ok">Active</span>
          </div>
          <div>
            <h3 className="font-display text-xl font-semibold tracking-wide text-paper">
              Extensiv Tools
            </h3>
            <p className="mt-1.5 text-sm leading-relaxed text-muted">
              Convert product creation, vendor SKU, listing, and purchase order files.
            </p>
          </div>
          <div className="mt-auto grid gap-2">
            <Link
              to="/warehouse-tools/extensiv-tools"
              className="nx-btn-secondary justify-start text-xs"
            >
              <FaFilePen className="h-3.5 w-3.5" />
              Product creation / Vendor SKU / Listing
            </Link>
            <Link
              to="/warehouse-tools/extensiv-tools/po-order"
              className="nx-btn-secondary justify-start text-xs"
            >
              <FaFilePen className="h-3.5 w-3.5" />
              Purchase order
            </Link>
          </div>
        </article>
      </div>
    </AppShell>
  )
}

export default WarehouseToolsView
